import { render, staticRenderFns } from "./DetailCombo.vue?vue&type=template&id=68e48b1c&lang=html"
import script from "./DetailCombo.vue?vue&type=script&lang=js"
export * from "./DetailCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports